/** 组织下拥有的告警
 */
const caution = {
  /** 根据当前组织id查询该组织拥有的所有设备的所有报警
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getDicDevModelCautionByOrgId: function (_this, url, devIds) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.orgDevCaution = res.data.data
      }
    })
  },
  /** 根据报警状态和设备名称搜索
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  searchCautionList: function (_this, url, cDisposeComment, devName, pageNum, pageSize) {
    _this.unTreadedTableloading = true
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        devName: devName,
        status: cDisposeComment,
        warnCode: _this.alarmType
      },
      params: {
        pageNum: pageNum,
        pageSize: pageSize
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        console.log(res)
        _this.unTreadedTable = res.data.data.pag
        _this.unTreadedTotalNum = res.data.data.total
        for (let item in _this.unTreadedTable) {
          let lng = _this.unTreadedTable[item].cLonBd09 * 1
          let lat = _this.unTreadedTable[item].cLatBd09 * 1
          _this.unTreadedTable[item].coordinate = lng.toFixed(6) + ',' + lat.toFixed(6)
        }
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
      _this.unTreadedTableloading = false
    })
  }
}
export default caution



// WEBPACK FOOTER //
// ./src/javascript/function/CautionFun.js